<template>
  <button
    :style="{
      width: '100%',
      textAlign: 'left',
      display: 'flex',
      gap: '14px',
      padding: '14px',
      cursor: 'pointer',
      fontFamily: 'inherit',
      borderRadius: '13px',
      border: `1px solid ${selected ? 'var(--p-primary-500)' : 'var(--p-content-border-color)'}`,
      background: selected ? 'var(--p-highlight-background)' : 'var(--p-content-background)',
    }"
    @click="emit('click')"
    @dblclick="emit('dblclick')"
  >
    <div :style="{ width: '76px', flexShrink: 0 }">
      <RecordMonogram :record="record" :config="config" :h="76" />
    </div>
    <div :style="{ flex: 1, minWidth: 0 }">
      <div :style="{ fontWeight: 700, fontSize: '14.5px', color: 'var(--p-text-color)', marginBottom: '2px' }">{{ config.primary(record) }}</div>
      <div v-if="config.secondary" :style="{ fontSize: '12.5px', color: 'var(--p-text-muted-color)', marginBottom: '9px' }">
        <RenderNode :node="secondary" />
      </div>
      <div :style="{ display: 'grid', gridTemplateColumns: 'repeat(2, minmax(0,1fr))', gap: '6px 16px' }">
        <div v-for="k in keys" :key="k" :style="{ display: 'flex', alignItems: 'center', gap: '6px', minWidth: 0, fontSize: '12px' }">
          <span :style="{ color: 'var(--p-surface-400)', flexShrink: 0, whiteSpace: 'nowrap' }">{{ metaFor(k).label || k }}</span>
          <span :style="{ color: 'var(--p-text-color)', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }">
            <FormatValue :record="record" :field-key="k" :field-definitions="fieldDefinitions" :field-meta="fieldMeta" />
          </span>
        </div>
      </div>
    </div>
  </button>
</template>

<script setup>
// Expanded-density card: thumbnail + title + secondary + 2-col field grid.
// Ported from collection-frame Card. Emits click / dblclick.
import { computed } from 'vue'
import RecordMonogram from './RecordMonogram.vue'
import FormatValue from '@/admin-collection-layout/lib/formatValue.js'
import RenderNode from '@/admin-collection-layout/lib/RenderNode.js'

const props = defineProps({
  record: { type: Object, required: true },
  config: { type: Object, required: true },
  fieldDefinitions: { type: Object, required: true },
  fieldMeta: { type: Object, default: () => ({}) },
  selected: { type: Boolean, default: false },
  cols: { type: Array, default: null },
})
const emit = defineEmits(['click', 'dblclick'])

const keys = computed(() => props.cols || props.config.cardFields || props.config.columns || [])
const secondary = computed(() => (props.config.secondary ? props.config.secondary(props.record) : null))
const metaFor = (k) => (props.fieldMeta || {})[k] || {}
</script>
